export default __webpack_public_path__ + "static/media/client.187a92c7.svg";